{
  "sidebar": {
    "linkedNone": "Inget länkat dokument"
  }
}
